<script>
import moment from "moment";
import { deleteSubscriberList } from "@/api/subscribers";
import AddSubscribersListModal from "@/view/components/subscribers/AddSubscribersListModal.vue";
export default {
  components: {
    AddSubscribersListModal
  },
  data() {
    return {
      search: "",
      singleSelect: false,
      selected: [],
      dialogDelete: false,
      dialogMsg: "Are you sure you want to delete this selected items?",
      error: false,
      editedIndex: -1,
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name"
        },
        { text: "Date Created", value: "created" },
        { text: "Subscribers", value: "subscribers" },
        { text: "Revenue", value: "revenue" },
        { text: "Open Rate", value: "open_rate" },
        { text: "Click Rate", value: "click_rate" }
      ],
      items: [],
      snackbar: false,
      text: "Updating subscribers list",
      timeout: 2000,
      loading: true
    };
  },
  computed: {
    getItems() {
      return this.$store.getters["getSubscribersList"];
    }
  },
  async mounted() {
    await this.$store.dispatch("getSubscribersList");
  },
  watch: {
    getItems(newVal) {
      this.items = newVal;
      this.snackbar = true;
      this.loading = false;
    }
  },
  methods: {
    exporItems() {
      // console.log("Export List", this.items);
      let csv = this.$papa.unparse(this.selected);
      this.$papa.download(
        csv,
        `SubscribersList-${moment().format("YYYY-MM-DD-HH-mm")}`
      );
    },
    removeItems() {
      if (this.selected.length == 0) {
        this.error = true;
        this.dialogMsg = "Please select atleast one item";
      } else {
        this.dialogMsg = "Are you sure you want to delete this selected items?";
        this.error = false;
      }
      this.dialogDelete = true;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    async removeItemsConfirm() {
      this.dialogDelete = false;

      for (let i = 0; i < this.selected.length; i++) {
        let item = this.selected[i];
        let response = await deleteSubscriberList(item.id);
        if (response == 204) {
          this.$bvToast.toast(`Deleted ${item.name}`, {
            title: "Subscriber List",
            autoHideDelay: 3000,
            appendToast: false,
            variant: "info"
          });
        }
      }
      this.selected = [];
      setTimeout(() => {
        this.$store.dispatch("getSubscribersList");
      }, 3000);
    },
    showModal(item) {
      this.$store.commit("setSubscribersListItem", null);
      this.$store.commit("setSubscribersListItem", item);
    }
  }
};
</script>

<template>
  <v-card flat>
    <v-row class="mb-8">
      <v-col cols="12" md="8">
        <v-btn class="mr-4" depressed tile @click="removeItems()">
          <v-icon left> mdi-delete </v-icon> Remove
        </v-btn>
        <v-btn class="mr-4" depressed tile @click="exporItems()">
          <v-icon left> mdi-file-export </v-icon>
          Export
        </v-btn>
        <v-btn class="mr-4" depressed tile v-b-modal.add-subscriber-list-modal>
          <v-icon left> mdi-plus-box </v-icon> Add
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <div class="input-group-text">
              <b-icon icon="search"></b-icon>
            </div>
          </div>
          <b-form-input v-model="search" placeholder="Search"></b-form-input>
        </div>
      </v-col>
    </v-row>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      item-key="id"
      :sort-by="['name']"
      show-select
      class="elevation-1"
      :search="search"
      :loading="loading"
      loading-text="Loading... Please wait"
    >
      <template v-slot:loading>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </template>
      <template v-slot:item.name="{ item }">
        <v-btn
          text
          color="primary"
          @click="showModal(item)"
          v-b-modal.add-subscriber-list-modal
        >
          {{ item.name }}
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogDelete" max-width="510px">
      <v-card>
        <v-card-title class="headline">{{ dialogMsg }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!error" color="blue darken-1" text @click="closeDelete"
            >Cancel</v-btn
          >
          <v-btn
            v-if="!error"
            color="blue darken-1"
            text
            @click="removeItemsConfirm"
            >OK</v-btn
          >

          <v-btn v-if="error" color="blue darken-1" text @click="closeDelete"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <add-subscribers-list-modal></add-subscribers-list-modal>
  </v-card>
</template>
